export interface LandingFeature {
  enabled: boolean;
  title: string;
  content: string;
  buttonText: string;
}

export interface PortalHeroImage {
  url: string;
  fileName: string;
}

export class PortalConfigurationView {
  invoiceFeatureEnabled: string = 'true';
  invoiceSubmissionRequiresLogin: string = 'false';
  invoiceHistoryEnabled: string = 'true';
  purchaseHistoryEnabled: string = 'true';
  changeRequestsEnabled: string = 'true';
  signupAndProfilingEnabled: string = 'true';
  registrationFeatureEnabled: string = 'true';
  purchaseOrdersEnabled: string = 'true';
  achEnabled: string = 'true';

  portalDisplayName: string = '';
  portalLogoUrl: string = '';
  portalPrimaryColor: string = '';
  portalSecondaryColor: string = '';
  portalHeaderColor: string = '';
  portalFooterColor: string = '';
  portalFeatureCardColor: string = '';
  portalLogoBackgroundColor: string = '';
  portalHeroImages: string = '';
  portalLandingContent: string = '';
  portalContactEmail: string = '';
  portalContactPhone: string = '';
  portalAddress: string = '';
  landingFeatures: string = '';
}
